import { render, staticRenderFns } from "./KitList.vue?vue&type=template&id=32d8ac0e"
import script from "./KitList.vue?vue&type=script&lang=ts"
export * from "./KitList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports